/* @ngInject */
export default function StartsWithFilter() {
    function escape(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    return function (items, filter) {
        let filtered = [];
        if (!items) {
            return filtered;
        }

        if (filter.showAllList && !filter.showFilteredList) {
            return items;
        }
        let value = '';
        if (filter.query && filter.query.selectedFormattedValue) {
            value = filter.query.selectedFormattedValue;
        }

        const match = new RegExp('^' + escape(value), 'i');
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            let noSpaceFormattedValue;
            let addZeroCharacterFormattedValue;
            let addedZeroMatch;

            if (item.formattedValue) {
                noSpaceFormattedValue = item.formattedValue.replace(/ +/g, '');
            } else {
                noSpaceFormattedValue = item.value.replace(/ +/g, '');
            }

            if (filter.query && filter.query.selectedFormattedValue && filter.query.selectedFormattedValue.charAt(0) === '.') {
                addZeroCharacterFormattedValue = '0' + value;
                addedZeroMatch = new RegExp('^' + escape(addZeroCharacterFormattedValue), 'i');
            }

            if (item.formattedValue && (match.test(item.formattedValue) || match.test(noSpaceFormattedValue) ||
                (addedZeroMatch && (addedZeroMatch.test(item.formattedValue) || addedZeroMatch.test(noSpaceFormattedValue)))
            )) {
                filtered.push(item);
            } else if (match.test(item.value) || match.test(noSpaceFormattedValue)) {
                filtered.push(item);
            }
        }
        return filtered;
    };
}
